export default __webpack_public_path__ + "7d50cfcb7fdf5bd337a00be9d920a0b0.woff";